import { NgModule } from '@angular/core';


import { PoolsRoutingModule } from './pools-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { PoolListComponent } from './components/pool-list/pool-list.component';
import { UIRouterModule } from "@uirouter/angular";
import { POOLS_STATES } from './pools.states';
import { PoolEditComponent } from './components/pool-edit/pool-edit.component';


@NgModule({
  declarations: [PoolListComponent, PoolEditComponent],
  imports: [
    SharedModule,
    PoolsRoutingModule,
    UIRouterModule.forChild({ states: [...POOLS_STATES] })
  ]
})
export class PoolsModule { }
